import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
import { startCase } from 'lodash';
import moment from 'moment';

import Empty from '../../components/common/Empty';
import Link from '../../components/common/Link';
import * as CatalogPageActionCreators from '../../redux/catalogPages';
import * as UiActionsCreators from '../../redux/ui';
import { SHOWING_FIELDS_CATELOG_PAGES } from '../../constants';

const { REACT_APP_FRONTEND_URL } = process.env;

const TableContainer = styled.div`
  background-color: #eeeeee;
  padding: 20px;
`;

const TablePaper = styled(Paper)`
  && {
    width: 100%;
    margin-top: 30px;
    overflow-x: auto;
  }
`;

const CatalogPagesTable = styled(Table)`
  && {
    min-width: 700px;
  }
`;

const CatalogPagesHead = styled(TableHead)`
  && {
    background-color: rgba(125, 188, 255, 0.6);
  }
`;

const EditButtonContainer = styled.div`
  margin-top: 5px;
`;

const CatalogPagesTableHeadFields = styled(TableCell)`
  && {
    color: black;
    font-weight: bold;
  }
`;
class CatalogPages extends Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.getCatalogPages();
  }

  getCellNames = () => {
    return [
      'name',
      'number_of_events',
      'url',
      'created_at',
      'actions',
      'active'
    ];
  };

  renderTableCellNames = () => {
    const cellNames = this.getCellNames();
    return cellNames.map((name, i) => {
      if (SHOWING_FIELDS_CATELOG_PAGES.includes(name)) {
        const displayName = startCase(name);
        return (
          <CatalogPagesTableHeadFields key={i}>
            {displayName}
          </CatalogPagesTableHeadFields>
        );
      }
      return null;
    });
  };
  async removeCatalogPage(archived, id) {
    const { actions } = this.props;
    if (archived) {
      await actions.updateCatalogPage(id, {
        archived: false
      });
      actions.getCatalogPages();
    } else {
      const r = window.confirm(
        'Are you sure you want to deactivate this Catalog Page?'
      );
      if (r === true) {
        await actions.removeCatalogPage(id);
        actions.getCatalogPages();
      }
    }
  }

  renderTableBody = () => {
    const { catalog_pages } = this.props;

    if (!catalog_pages) return <TableRow />;
    const cellNames = this.getCellNames();
    return catalog_pages.map((catalog_page, i) => {
      return (
        <TableRow key={i}>
          {cellNames.map((field, index) => {
            if (SHOWING_FIELDS_CATELOG_PAGES.includes(field)) {
              if (field) {
                let value;
                if (field === 'created_at' || field === 'archived_at') {
                  value = catalog_page[field]
                    ? moment(catalog_page[field]).format('LLLL')
                    : '-';
                } else if (typeof catalog_page[field] === 'boolean') {
                  value = catalog_page[field].toString();
                } else if (field === 'url') {
                  const eventURL = `${REACT_APP_FRONTEND_URL}/${
                    catalog_page[field]
                  }`;
                  value = (
                    <div>
                      <a href={eventURL} target="_blank">
                        {eventURL}
                      </a>
                    </div>
                  );
                } else if (field === 'actions') {
                  return (
                    <TableCell key={index}>
                      <EditButtonContainer>
                        <Link to={`/catalog-pages/${catalog_page.id}/edit`}>
                          <Button variant="outlined" color="primary">
                            Edit
                          </Button>
                        </Link>
                      </EditButtonContainer>
                    </TableCell>
                  );
                } else if (field === 'active') {
                  return (
                    <TableCell key={index}>
                      <EditButtonContainer>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() =>
                            this.removeCatalogPage(
                              catalog_page.archived,
                              catalog_page.id
                            )
                          }
                        >
                          {catalog_page.archived ? 'Activate' : 'Deactivate'}
                        </Button>
                      </EditButtonContainer>
                    </TableCell>
                  );
                } else {
                  value = catalog_page[field];
                }
                return <TableCell key={index}>{value}</TableCell>;
              }
            }
            return null;
          })}
        </TableRow>
      );
    });
  };

  renderTable = () => {
    const { ui } = this.props;
    if (ui === 'complete') {
      return (
        <CatalogPagesTable>
          <CatalogPagesHead>
            <TableRow>{this.renderTableCellNames()}</TableRow>
          </CatalogPagesHead>
          <TableBody>{this.renderTableBody()}</TableBody>
        </CatalogPagesTable>
      );
    }

    return null;
  };

  renderEmpty = () => (this.props.ui === 'empty' ? <Empty /> : null);

  render() {
    return (
      <div>
        <EditButtonContainer>
          <Link to={`/catalog-pages/new`}>
            <Button variant="outlined" color="primary">
              Add Catalog Page
            </Button>
          </Link>
        </EditButtonContainer>
        <TableContainer>
          <TablePaper>
            {this.renderTable()}
            {this.renderEmpty()}
          </TablePaper>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  catalog_pages: state.catalog_pages.catalog_pages,
  ui: state.ui.uiState
});

const ActionCreators = Object.assign(
  {},
  CatalogPageActionCreators,
  UiActionsCreators
);

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CatalogPages);



// WEBPACK FOOTER //
// ./src/pages/catalog-pages/index.js